import { render, staticRenderFns } from "./ManageDaRateDialog.vue?vue&type=template&id=0ff86574"
import script from "./ManageDaRateDialog.vue?vue&type=script&lang=js"
export * from "./ManageDaRateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports